import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Section from '@common/Section';
import Row from '@common/Row';
import Video from '@common/Video';
import RichText from '@common/RichText';
import SmallTitle from '@common/SmallTitle';

import Buttons from '@common/blocks/flex/Buttons';
import Images from '@common/blocks/flex/Images';
import Links from '@common/blocks/flex/Links';
import MobileLinks from '@common/blocks/flex/MobileLinks';

import * as styles from '@common/blocks/flex/homepage-video/homepage-video.module.scss';

const HomepageVideo = ({ data }) => {
  const {
    title,
    showTitle,
    text,
    textAlignment,
    listClass,
    imagePosition,
    imagePositionTop,
    imagePositionTopLg,
    buttons,
    images,
    links,
    video,
    topMargin,
    bottomMargin,
    bgColour,
    bgNoPadding,
    bgFullwidth
  } = data;
  return (
    <Section spacing={clsx('pt-lg-8', topMargin, bottomMargin ? bottomMargin : 'mb-7')} className={clsx({
        [`bg-${bgColour}`]: bgColour,
        'py-5': bgColour && !bgNoPadding,
        'container card': !bgFullwidth
      })}>
      <Container className='position-relative'>
        <div className={styles.gridContainer}>
          <div id={styles.shape1} className='bg-teal'/>
          <div id={styles.shape2} className='bg-green'/>
          <div id={styles.shape3} className='bg-teal'/>
          <div id={styles.shape4} className='bg-yellow'/>
          <div id={styles.shape5} className='bg-red'/>
          <div id={styles.shape6} className='bg-green'/>
          <div id={styles.shape7} className='bg-red'/>
          <div id={styles.shape8} className='bg-teal'/>
        </div>
        <Row className={clsx(`d-flex flex-column align-items-center px-xl-5`, {
            'flex-md-row-reverse': imagePosition === 'Left' && !imagePositionTopLg,
            'flex-md-row': imagePosition === 'Right' && !imagePositionTopLg,
            'flex-column-reverse': imagePositionTop || imagePositionTopLg,
            'justify-content-center': (!images || !links) && textAlignment === 'Center'
          })}>
          {(showTitle && title) &&
            <SmallTitle>{title}</SmallTitle>
          }
          {video &&
            <div className='col'>
              {text &&
                <div className={styles.videoText}>
                  <RichText
                    json={text}
                    h1={'mb-3'}
                    h2={'text-center'}
                    ul={listClass}
                    li={'py-2'}
                    a='fs-16'
                  />
                </div>
              }
              <div className={clsx('mt-xl-5', styles.videoContainer)}>
                <Video videoId={video.videoId} image={video.image} />
              </div>
            </div>
          }
          {buttons && 
            <Buttons data={data} />
          }
          {images &&
            <Images data={data} />
          }
          {links &&
            <Links data={data} />
          }
        </Row>
        {links &&
          <MobileLinks data={data} />
        }
      </Container>
    </Section>
  )
}

export default HomepageVideo
